module.exports = __webpack_public_path__ + "static/media/oberflex-erablecanadien-1200x2490.3ac404d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-erablecanadien-1200x2490.jpg
// module id = 1004
// module chunks = 37